export default "__VITE_ASSET__BeqMJgx4__"